module.exports = __webpack_public_path__ + "static/img/fiveab.0af7a6ae.png";